import React from 'react'
import { Link } from 'gatsby'
import Img from 'gatsby-image'

export default ({ article }) => (
  <div className="my-4 mx-2">
    <Link to={`/blog/${article.slug}`}>
      <Img className="rounded-sm" alt="article-preview" fluid={article.heroImage.fluid} />
      <h2 className="font-bold text-xl md:text-2xl pt-6 text-gray-800">
        {article.title}
      </h2>
    </Link>
    <p className="text-sm text-gray-700 mb-2 sm:mb-4">{article.publishDate}</p>
    <p
      className="text-md text-gray-800"
      dangerouslySetInnerHTML={{
      __html: article.description.childMarkdownRemark.html,
      }}
    >
      {/* {String(article.description.childMarkdownRemark.html.replace("<p>","").replace("</p>","").substring(0,100).concat("..."))} */}
    </p>
  </div>
)
